import React from 'react';
import {ConnectedRouter} from 'connected-react-router';

import {history} from 'store';
import InitWrapper from "./components/InitWrapper";
import useAdaBot from "./util/hooks/useAdaBot";

const App = () => {
  useAdaBot();

  return (
      <ConnectedRouter history={history}>
        <React.StrictMode>
          <InitWrapper/>
        </React.StrictMode>
      </ConnectedRouter>
  )
};

export default App;
